import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import PostMioLogo from '../components/PostMioLogo';

export default function ResetPassword() {
  const navigate = useNavigate();

  const [checked, setChecked]           = useState(false);
  const [sessionValid, setSessionValid]  = useState(false);

  const [password, setPassword]         = useState('');
  const [confirm, setConfirm]           = useState('');
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);
  const [success, setSuccess]           = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setSessionValid(true);
      setChecked(true);
    });
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError(null);

    if (password.length < 8) {
      setError('La password deve essere di almeno 8 caratteri.');
      return;
    }
    if (password !== confirm) {
      setError('Le password non coincidono.');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
      setTimeout(() => navigate('/dashboard', { replace: true }), 2000);
    }
  };

  if (!checked) return null;

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4"
      style={{ fontFamily: 'DM Sans, sans-serif' }}
    >
      <div className="w-full max-w-md">

        {/* Logo */}
        <div className="text-center mb-10">
          <Link to="/" className="inline-block">
            <PostMioLogo size="md" variant="dark" />
          </Link>
          <p className="text-[#7A7A7A] text-xs uppercase tracking-[0.3em] mt-2">
            Reset password
          </p>
        </div>

        {/* Card */}
        <div className="bg-[#141414] border border-[#2C2C2C] rounded-2xl p-8 shadow-xl">

          {!sessionValid ? (
            <div className="text-center space-y-4">
              <p className="text-sm text-[#A02020]">Link non valido o scaduto.</p>
              <Link to="/login" className="text-xs text-[#C9922A] hover:text-[#E5B050] transition-colors">
                Torna al login →
              </Link>
            </div>
          ) : success ? (
            <p className="text-center text-sm font-semibold" style={{ color: '#C9922A' }}>
              Password aggiornata.
            </p>
          ) : (
            <form onSubmit={handleUpdate} className="space-y-4">
              {error && (
                <div className="p-4 bg-[#A02020]/10 border border-[#A02020]/30 rounded-xl text-sm text-[#F0EDE8] text-center">
                  {error}
                </div>
              )}
              <input
                type="password"
                placeholder="Nuova password"
                className="w-full bg-[#0A0A0A] border border-[#2C2C2C] rounded-xl px-5 py-4 text-[#F0EDE8] text-sm placeholder-[#606060] focus:border-[#C9922A] outline-none transition-all"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Conferma password"
                className="w-full bg-[#0A0A0A] border border-[#2C2C2C] rounded-xl px-5 py-4 text-[#F0EDE8] text-sm placeholder-[#606060] focus:border-[#C9922A] outline-none transition-all"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#C9922A] hover:bg-[#E5B050] disabled:opacity-40 disabled:cursor-not-allowed font-bold py-4 rounded-xl text-sm uppercase tracking-[0.2em] transition-all mt-2"
                style={{ color: '#000000' }}
              >
                {loading ? 'Aggiornamento...' : 'Aggiorna password'}
              </button>
            </form>
          )}

        </div>
      </div>
    </div>
  );
}
